import { Card, CardContent } from '@/components/ui/card';
import { useLanguage } from '@/i18n/LanguageContext';
import { CHART_COLORS } from '@/components/admin/analytics/chartColors';

export const UserRolesCard = ({ roleData, totalUsers }) => {
  const { t } = useLanguage();
  return (
    <Card className="bg-card border-border">
      <CardContent className="p-6">
        <h3 className="text-lg font-bold mb-4">{t('analytics.userRoles')}</h3>
        {roleData.length > 0 ? (
          <div className="space-y-4">
            {roleData.map((role, i) => (
              <div key={role.name}>
                <div className="flex justify-between text-sm mb-1">
                  <span className="text-muted-foreground">{role.name}</span>
                  <span className="font-bold">{role.value}</span>
                </div>
                <div className="h-2 bg-muted rounded-full overflow-hidden">
                  <div
                    className="h-full rounded-full transition-all duration-500"
                    style={{
                      width: `${Math.max(5, (role.value / totalUsers) * 100)}%`,
                      background: CHART_COLORS[i % CHART_COLORS.length],
                    }}
                  />
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="h-40 flex items-center justify-center text-muted-foreground text-sm">
            {t('analytics.noData')}
          </div>
        )}
      </CardContent>
    </Card>
  );
};
